import { render, staticRenderFns } from "./ExtractClass.vue?vue&type=template&id=4727cf73&"
import script from "./ExtractClass.vue?vue&type=script&lang=ts&"
export * from "./ExtractClass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports